import React, { useState, useContext, useRef, useEffect } from "react";
import { getChargeButtonTitle } from "../../../utils";
import { Grid, Button, Chip } from "@mui/material";
import { UBInput, UBButton } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { AmountSuggestion } from "../../../constants/index";
import styles from "./styles.module.css";
import { NewPlusIcon } from "../../../assets/icons/icon";
import { useLocation } from "react-router-dom";

import { analytics, triggerLogEvent } from "../../../config/firebase";

const NumKeypad = ({
  totalAmount = 0,
  confirmSale = () => {},
  customer,
  isLoadingbtn = false,
  handleCashLogEvents = () => {},
}) => {
  const [changeAmount, setchangeAmount] = useState("");
  const [isFocusInput, setIsFocusInput] = useState(false);
  const inputRef = useRef(null);
  const location = useLocation();
  const [I18n] = useContext(LanguageContext);
  const ValidateAmount = (amount) => String(amount).length <= 30;

  const handleChange = (key, value) => {
    setchangeAmount(value);
    if (value.length >= 1 && changeAmount.length == 0) handleCashLogEvents();
  };
  const concateNumber = (number) => {
    const inputElement = inputRef.current;
    let value = String(changeAmount) + number;
    if (ValidateAmount(value) || number === "C") {
      setchangeAmount(number === "C" ? "" : value);
    }
    triggerLogEvent(analytics, "pos_payment_cash_keypad");
    inputElement?.focus();
  };

  const addAmountFromSuggestionNumber = (number) => {
    triggerLogEvent(analytics, "pos_payment_cash_chips", { chip: number });
    const inputElement = inputRef.current;
    let value = Number(number) + Number(changeAmount);
    if (ValidateAmount(value)) {
      setchangeAmount(value);
    }
    inputElement?.focus();
  };
  const isValid = () =>
    Boolean(
      (totalAmount || location?.state?.totalAmount) <= (changeAmount || 0)
    );

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && inputRef?.current) {
        event.preventDefault();
        inputRef?.current?.focus();
      }
      if (event.shiftKey && event.key === "Enter") {
        event.preventDefault();
        if (!isLoadingbtn && isValid()) {
          confirmSale(changeAmount, customer);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isLoadingbtn, changeAmount, totalAmount, inputRef, customer, location]);

  useEffect(() => {
    if (inputRef?.current) inputRef.current.focus();
  }, []);

  return (
    <Grid
      container
      className={`${styles.container} h-100`}
      data-cash-keypad
    >
      <form id="num_keypad_form">
        <UBInput
          inputId="num_keypad_input"
          label={
            <span className={styles.cashLabel}>
              {I18n.enter_cash_amount} <span>*</span>
            </span>
          }
          prefix="Rs."
          baseClassname="inputCashStyleWrapper"
          className={`input-cash-style ${isFocusInput ? "active" : ""}`}
          onChange={handleChange}
          value={changeAmount}
          onFocus={() => setIsFocusInput(true)}
          onBlur={() => setIsFocusInput(false)}
          maxLength={30}
          onlyNumbers={true}
          inputRef={inputRef}
          id="cash_amount"
        />
        <div className={styles.chipRow}>
          {AmountSuggestion.map((item) => (
            <Chip
              id={`${item}_id`}
              key={item}
              onClick={() => addAmountFromSuggestionNumber(item)}
              label={
                <>
                  <NewPlusIcon
                    width={14}
                    height={14}
                    aria-hidden
                  />
                  Rs. {item}
                </>
              }
              className={styles.suggestionChip}
            />
          ))}
        </div>
      </form>
      <div className={styles.numpadOuter}>
        <div className={styles.numpad}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, "00", 0, "C"].map((value) => (
            <div className={styles.numpadKey} key={value}>
              <Button
                id={`${value}_id`}
                className={styles.numericButton}
                fullWidth
                onClick={() => concateNumber(value)}
              >
                {value}
              </Button>
            </div>
          ))}
        </div>
        <UBButton
          id="charge_rs_id"
          title={getChargeButtonTitle(I18n, totalAmount)}
          className={` ubPrimaryButton ${styles.chargeCTA} ${isValid() ? "active" : ""}`}
          disabled={isLoadingbtn || !isValid()}
          onClick={() => confirmSale(changeAmount, customer)}
          style={{
            border: isValid() ? "" : "1px solid #D0D3D9",
          }}
        />
      </div>
    </Grid>
  );
};

export default NumKeypad;
